import { Module } from 'vuex';
import { RootState } from '@/store/index';
import { getUserMenu } from '@/api/accountEndpoint';

type userMenuState = {
  firstname: string;
  lastname: string;
};

const userMenuModule: Module<userMenuState, RootState> = {
  namespaced: true,
  state: {
    firstname: '',
    lastname: ''
    },
  getters: {
    userMenu(state) {
      return state;
    },
  },

  mutations: {
    set(state, value: userMenuState) {
      Object.assign(state, value);
    },
  },

  actions: {
    async receive({ commit }) {
      const userMenu = await getUserMenu();
      commit('set', userMenu);
    },
  },
};

export default userMenuModule;
